import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageableResponse } from 'src/@core/interfaces/pageable-response';
import { AppService } from 'src/@core/services/app.service';
import { EmploymentService } from 'src/@core/services/employment/employment.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions';
import { MatDialog } from '@angular/material/dialog';
import { AddVendorComponent } from '../vendors/add-vendor/add-vendor.component';

@Component({
  selector: 'hour4u-admin-assign-vendor',
  templateUrl: './assign-vendor.component.html',
  styleUrls: ['./assign-vendor.component.scss']
})
export class AssignVendorComponent implements OnInit {
  form: FormGroup;
  dialogData: any = {};
  totalBill: number = 0;
  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;
  vendors: any[] = [];

  jobTypes: any[];
  enterprises: any[];
  fromWhere: string;

  dataFromPopup: boolean;
  submitted = false;
  activationTypes: any;
  selectedFileNames: string[] = [];
  isSocietyActivationSelected: boolean = false;
  selectedValue: any;
  profile = this.appService.getCurrentAccount();
  isSuper: boolean = false;

  selectedData: any = null;
  isUpdate: boolean = false;
  perList: any[] = [
    {
      name: 'Task',
      value: 'Task'
    },
    // {
    //   name: 'PER DURATION',
    //   value: 'PER DURATION'
    // },
    {
      name: 'Hour',
      value: 'Hour'
    },
    {
      name: 'Day',
      value: 'Day'
    },
    {
      name: 'Week',
      value: 'Week'
    },
    {
      name: 'Month',
      value: 'Month'
    },
  ];




  term = '';
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  searchParams = [];
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 20;
  teamMembers: any[] = [];
  isLoading: boolean = false;
  diameter = 30;
  color: string;
  mode = 'indeterminate';
  isSearch = true;
  timeoutRef: ReturnType<typeof setTimeout>;
  displayedColumns: any[] = ['name', 'mobile', 'email'];
  projectType: string = "";


  constructor(
    private _fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private notify: NotificationService,
    public jobService: JobService,
    public employmentService: EmploymentService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AssignVendorComponent>,
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.dialogData = this.data;
  }

  ngAfterViewInit() {
    this.setupFormValues();
    this.fetchVendors();
    this.projectType = this.data.type;
    console.log(this.data)
  }

  fetchVendors(selectVendor?: any) {
    this.searchParams = [];
    this.vendors = [];
    const entityId = this.profile.entity.id;
    this.isLoading = true;

    if (entityId) {
      if (this.term) {
        this.searchParams.push({ column: 'query', content: this.term });
      }

      const sortField = 'createdOn';
      const sortOrder = 'desc';
      const entityType = 'VENDOR'

      this.jobService.searchAndSortVendors(
        entityId,
        this.pageIndex,
        this.pageSize,
        sortField,
        sortOrder,
        entityType,
        this.searchParams
      ).subscribe(
        (data: PageableResponse<any>) => {
          this.vendors = data.content;
          console.log(this.vendors, selectVendor)
          this.isLoading = false;
          this.resultsLength = data.totalElements;
          if (selectVendor && selectVendor.childEntity && selectVendor.childEntity.id) {
            let selectedVendor = this.vendors.find(item => item.id === selectVendor.childEntity.id);
            if (selectedVendor) {
              this.form.controls['selectedVendor'].setValue(selectedVendor.id);
              this.form.controls['selectedVendor'].updateValueAndValidity();
            }
          }
        },
        error => {
          this.isLoading = false;
          this.notify.showMessage('Something went wrong while fetching vendors!', 2000);
        }
      );
    } else {
      console.warn('Entity ID is not available. Unable to fetch vendors.');
    }
  }

  initializeForm() {
    this.form = this._fb.group({
      jobId: [''],
      jobTypeId: ['', Validators.required],
      employerId: ['', Validators.required],
      selectedVendor: ['', Validators.required],
      entityIds: [''],
      // rateCards: this._fb.array([]),
      // variableJobRateCards: this._fb.array([]),
      // billingType: [this.data.billingType, Validators.required],
      workOrderApprovalRequired: [false],
      quotationApprovalRequired: [false],
      purchaseOrderRequired: [false],
      isBillingRequired: [true],
      billingType: ['FIXED'],
      rateCards: this._fb.array([this.createFixRateCard()]),
      variableJobRateCards: this._fb.array([]),
      quotationRequired: [false]
    });
  }

  // Utility method to create Fix Rate Cards FormGroup
  createFixRateCard(): FormGroup {
    return this._fb.group({
      type: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      totalAmount: [''],
      saved: [false],
      expanded: [true],
      days: ['', [Validators.required]],
      description: ['']
    });
  }

  // Utility method to create Variable Rate Cards FormGroup
  createVariableRateCard(): FormGroup {
    return this._fb.group({
      type: ['', Validators.required],
      quantity: ['', Validators.required],
      rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      totalAmount: [''],
      saved: [false],
      expanded: [true],
      description: [''],
      per: ['', Validators.required]
    });
  }

  get rateCards(): FormArray {
    return this.form.get('rateCards') as FormArray;
  }

  get variableJobRateCards(): FormArray {
    return this.form.get('variableJobRateCards') as FormArray;
  }

  // select Billing Type
  selectBillingType(type) {
    this.form.controls['billingType'].setValue(type);
    this.form.controls['billingType'].updateValueAndValidity();

    const rateCardsArray = this.form.get('rateCards') as FormArray;
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;

    if (this.form.controls['billingType'].value == 'FIXED') {
      rateCardsArray.clear();
      rateCardsArray.push(this.createFixRateCard());
    }

    if (this.form.controls['billingType'].value == 'VARIABLE') {
      variableRateCardsArray.clear();
      variableRateCardsArray.push(this.createVariableRateCard());
    }

    if (this.form.controls['billingType'].value == 'FIXED_AND_VARIABLE') {
      rateCardsArray.clear();
      rateCardsArray.push(this.createFixRateCard());
      variableRateCardsArray.clear();
      variableRateCardsArray.push(this.createVariableRateCard());
    }
  }

  // toggle Expand
  toggleExpand(index: number, forWhat: string) {
    if (forWhat == 'FIXED') {
      const rateCards = this.form.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup, idx) => {
        if (index == idx) {
          rateCard.controls['expanded'].setValue(!rateCard.controls['expanded'].value);
        }
      });
    }

    if (forWhat == 'VARIABLE') {
      const variableJobRateCards = this.form.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup, idx) => {
        if (index == idx) {
          rateCard.controls['expanded'].setValue(!rateCard.controls['expanded'].value);
        }
      });
    }
  }

  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    if (this.form.controls['billingType'].value.includes('FIXED')) {
      const rateCards = this.form.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        let rate = 0;
        if (rateCard.get('rate')) {
          rate = rateCard.get('rate').value;
        }
        let days = 0;
        if (rateCard.get('days')) {
          days = rateCard.get('days').value;
        }
        totalBilling = totalBilling + (quantity * rate * days);
      });
    }

    if (this.form.controls['billingType'].value.includes('VARIABLE')) {
      const variableJobRateCards = this.form.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        let rate = 0;
        if (rateCard.get('rate')) {
          rate = rateCard.get('rate').value;
        }
        totalBilling = totalBilling + (quantity * rate);
      });
    }
    return totalBilling;
  }

  // get Total Billing's GST
  getTotalBillingGST() {
    let totalBillingGST = 0;
    if (this.form.controls['billingType'].value.includes('FIXED')) {
      const rateCards = this.form.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        let rate = 0;
        if (rateCard.get('rate')) {
          rate = rateCard.get('rate').value;
        }
        let days = 0;
        if (rateCard.get('days')) {
          days = rateCard.get('days').value;
        }
        totalBillingGST = totalBillingGST + (quantity * rate * days);
      });
    }

    if (this.form.controls['billingType'].value.includes('VARIABLE')) {
      const variableJobRateCards = this.form.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        let rate = 0;
        if (rateCard.get('rate')) {
          rate = rateCard.get('rate').value;
        }
        totalBillingGST = totalBillingGST + (quantity * rate);
      });
    }
    return totalBillingGST * 0.18;
  }

  // get Total Billing With GST
  getTotalBillingWithGST() {
    let totalBillingWithGST = 0;

    if (this.form.controls['billingType'].value.includes('FIXED')) {
      const rateCards = this.form.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        let rate = 0;
        if (rateCard.get('rate')) {
          rate = rateCard.get('rate').value;
        }
        let days = 0;
        if (rateCard.get('days')) {
          days = rateCard.get('days').value;
        }
        totalBillingWithGST = totalBillingWithGST + (quantity * rate * days);
      });
    }

    if (this.form.controls['billingType'].value.includes('VARIABLE')) {
      const variableJobRateCards = this.form.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        let rate = 0;
        if (rateCard.get('rate')) {
          rate = rateCard.get('rate').value;
        }
        totalBillingWithGST = totalBillingWithGST + (quantity * rate);
      });
    }
    return totalBillingWithGST * 1.18;
  }

  onSlideToggleChange(event, field) {
    if (field === 'isBillingRequired') {
      const rateCardsArray = this.form.get('rateCards') as FormArray;
      const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
      if (!event.checked) {
        this.form.controls['billingType'].setValue('NONE');
        this.form.controls['billingType'].updateValueAndValidity();
        if (this.form.controls['billingType'].value.includes('NONE')) {
          variableRateCardsArray.clear();
          rateCardsArray.clear();
        }
        return;
      } else {
        this.form.controls['billingType'].setValue('FIXED');
        this.form.controls['billingType'].updateValueAndValidity();
        if (this.form.controls['billingType'].value == 'FIXED') {
          variableRateCardsArray.clear();
          rateCardsArray.push(this.createFixRateCard());
        }

        if (this.form.controls['billingType'].value == 'VARIABLE') {
          rateCardsArray.clear();
          variableRateCardsArray.push(this.createVariableRateCard());
        }
      }
    }

    if (field === 'quotationRequired') {
      if (event.checked) {
      } else {
        this.form.controls['purchaseOrderRequired'].setValue(false);
      }
      this.form.controls['purchaseOrderRequired'].updateValueAndValidity();
    }

    if (field === 'quotationApprovalRequired') {
      if (event.checked) {
        this.form.controls['quotationRequired'].setValue(true);
      } else {
        this.form.controls['quotationRequired'].setValue(false);
        this.form.controls['purchaseOrderRequired'].setValue(false);
      }
      this.form.controls['purchaseOrderRequired'].updateValueAndValidity();
      this.form.controls['quotationRequired'].updateValueAndValidity();
    }
  }

  setupFormValues() {
    if (this.dialogData) {
      this.form.patchValue(this.dialogData);
      this.form.controls['jobId'].patchValue(
        this.dialogData.id
      )
      console.log(this.form.value)
      this.setRateCards(this.dialogData.rateCards || []);
      this.setVariableRateCards(this.dialogData.variableJobRateCards || []);
      this.totalBill = this.calculateTotalBill();
    }
  }

  setRateCards(rateCards: any[]) {
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.clear();
    rateCards.forEach(rateCard => {
      rateCardsArray.push(this._fb.group({
        type: [rateCard.type, Validators.required],
        quantity: [rateCard.quantity, [Validators.required, Validators.pattern(/^\d+$/)]],
        rate: [rateCard.rate, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        totalAmount: [rateCard.totalAmount],
        saved: [false],
        expanded: [true],
        days: [rateCard.days, [Validators.required]],
        description: [rateCard.description]
      }));
    });
    // this.updateTotalBill();
  }

  setVariableRateCards(variableRateCards: any[]) {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.clear();
    variableRateCards.forEach(variableCard => {
      variableRateCardsArray.push(this._fb.group({
        type: [variableCard.type, Validators.required],
        quantity: [variableCard.quantity, Validators.required],
        rate: [variableCard.rate, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
        totalAmount: [variableCard.totalAmount],
        saved: [false],
        expanded: [true],
        description: [variableCard.description],
        per: [variableCard.per, Validators.required]
      }));
    });
    // this.updateTotalBill();
  }

  addMoreRateCards() {
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.push(this.createFixRateCard());
  }

  addMoreVariableRateCards() {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.push(this.createVariableRateCard());
  }

  // Method to delete a specific 'rateCard' by index
  deleteRateCard(index: number) {
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    rateCardsArray.removeAt(index);
  }

  // Method to delete a specific 'rateCard' by index
  deleteVariableRateCard(index: number) {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.removeAt(index);
  }

  // createRateCard(defaultType: string = ''): FormGroup {
  //   return this._fb.group({
  //     type: [defaultType],
  //     quantity: ['', Validators.required],
  //     rate: ['', Validators.required],
  //     totalAmount: [''],
  //     saved: [false]
  //   });
  // }

  // deleteRateCard(index: number) {
  //   const rateCardsArray = this.form.get('rateCards') as FormArray;
  //   rateCardsArray.removeAt(index);
  //   this.updateTotalBill();
  // }

  // deleteVariableRateCard(index: number) {
  //   const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
  //   variableRateCardsArray.removeAt(index);
  //   this.updateTotalBill();
  // }

  calculateTotalBill(): number {
    let total = 0;
    const rateCards = this.form.get('rateCards') as FormArray;
    rateCards.controls.forEach((control: FormGroup) => {
      total += control.value.quantity * control.value.rate;
    });
    return total;
  }

  updateTotalBill() {
    this.totalBill = this.calculateTotalBill();
  }

  selectedBillingOption() {
    this.setDefaultVariablePay();
    console.log(this.form.controls['billingType'].value)
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    const rateCardsArray = this.form.get('rateCards') as FormArray;
    if (this.form.controls['billingType'].value == 'FIXED') {
      rateCardsArray.clear();
      variableRateCardsArray.clear();
      // this.setDefaultFixedPay();
    }

    if (this.form.controls['billingType'].value == 'VARIABLE') {
      rateCardsArray.clear();
      variableRateCardsArray.clear();
      this.setDefaultVariablePay();
    }

    if (this.form.controls['billingType'].value == 'FIXED_AND_VARIABLE') {
      rateCardsArray.clear();
      variableRateCardsArray.clear();
      // this.setDefaultFixedPay();
      this.setDefaultVariablePay();
    }
  }

  // setDefaultFixedPay() {
  //   const rateCardsArray = this.form.get('rateCards') as FormArray;
  //   rateCardsArray.clear();
  //   if (this.form.value.billingType.includes("FIXED")) {
  //     if (this.projectType == 'BRANDING') {
  //       rateCardsArray.push(this.createRateCard());
  //     } else {
  //       rateCardsArray.push(this.createRateCard('Promoters'));
  //       rateCardsArray.push(this.createRateCard('Transportation'));
  //       rateCardsArray.push(this.createRateCard('Goods for activity'));
  //     }
  //   }
  // }

  setDefaultVariablePay() {
    const variableRateCardsArray = this.form.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.clear();
    if (this.form.value.billingType.includes("VARIABLE")) {
      // variableRateCardsArray.push(this.createVariableRateCard('Tasks'));
    }
  }

  // createVariableRateCard(defaultType: string = ''): FormGroup {
  //   console.log("defaultType", defaultType)
  //   return this._fb.group({
  //     type: [defaultType],
  //     quantity: [''],
  //     rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
  //     totalAmount: [''],
  //     saved: [false]
  //   });
  // }
  onVendorChange(event) {
    this.form.controls['selectedVendor'].setValue(event.value);

    const entityId = event.value;
    this.form.controls['entityIds'].patchValue([entityId]);

    console.log("this.form.controls['selectedVendor']", this.form.value)
  }


  onSubmit() {
    this.isLoading = true;
    const formValue = this.form.value;
    // Constructing the payload as per the first structure
    const payload = {
      jobId: formValue.jobId,
      entityIds: formValue.entityIds,
      jobMeta: {
        employerId: formValue.employerId,
        employerName: formValue.employerName,
        jobTypeId: formValue.jobTypeId,
        code: formValue.code,
        title: formValue.title,
        tasks: formValue.tasks,
        description: formValue.description,
        prerequisites: formValue.prerequisites,
        dressCodeMale: formValue.dressCodeMale,
        dressCodeFemale: formValue.dressCodeFemale,
        requirements: formValue.requirements,
        approved: formValue.approved,
        globalTemplate: formValue.globalTemplate,
        city: formValue.city,
        type: formValue.type,
        deliverables: formValue.deliverables,
        attachments: formValue.attachments,
        elements: formValue.elements,
        rateCards: formValue.rateCards,
        variableJobRateCards: formValue.variableJobRateCards,
        activationImageRequired: formValue.activationImageRequired,
        attendanceLogInSelfieRequired: formValue.attendanceLogInSelfieRequired,
        attendanceLogOutSelfieRequired: formValue.attendanceLogOutSelfieRequired,
        attendanceLocationTrackerRequired: formValue.attendanceLocationTrackerRequired,
        attendanceAtVenueRequired: formValue.attendanceAtVenueRequired,
        locationTrackingFrequency: formValue.locationTrackingFrequency,
        quotationRequired: formValue.quotationRequired,
        venueInformation: formValue.venueInformation,
        billingType: formValue.billingType,
        manpowerTrackingRequired: formValue.manpowerTrackingRequired,
        signatureRequired: formValue.signatureRequired,
        workOrderApprovalRequired: formValue.workOrderApprovalRequired,
        quotationApprovalRequired: formValue.quotationApprovalRequired,
        purchaseOrderRequired: formValue.purchaseOrderRequired
      }
    };

    if (payload.jobMeta.billingType == "NONE") {
      payload.jobMeta.quotationRequired = false;
    } else {
      payload.jobMeta.quotationRequired = true;
    }

    console.log(payload);
    // Sending the formatted payload to the API
    this.employmentService.assignEntityToProject(payload).subscribe(res => {
      this.isLoading = false;
      console.log(res);
      this.notify.showMessage("Selected vendor assigned successfully!", 2000);
      this.dialogRef.close(true);
    }, (err: any) => {
      this.isLoading = false;
      this.notify.showMessage('Something went wrong!', 2000);
    });
  }


  // add quote
  addQuote() {

    console.log()

    const obj = {

    }

    this.jobService.createQuotation(this.form.value).subscribe(res => {
      console.log(res)
      this.isLoading = false;
      if (res) {
        this.notify.showMessage('Quotation sent successfully!', 2000);
        this.dialogRef.close(true);
      }
    }, (err => {
      console.log(err)
      this.isLoading = false;
    }))
  }

  // rateCards(): FormArray {
  //   return this.form.get('rateCards') as FormArray;
  // }

  // variableJobRateCards(): FormArray {
  //   return this.form.get('variableJobRateCards') as FormArray;
  // }

  logQuotationApprovalRequired(value: boolean): void {
    this.form.get('purchaseOrderRequired').setValue(false);
    console.log('Quotation Approval Required:', value);
  }

  addVendor() {
    const dialogRef = this.dialog.open(AddVendorComponent, {
      width: '600px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.fetchVendors(result);
      }
    });

  }

}